import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostHog } from 'posthog-js/react';
import { IconUsers } from '@tabler/icons-react';
import ReferralInviteBuilder from './ReferralInviteBuilder';

// Friend-referral entry point: opens the invite builder, which drives the real backend flow
// (createReferralInvite -> shareable link -> the friend accepts and their map generates).
// The +5/+5 diamonds are granted server-side when the referral map completes; this card
// grants nothing itself.
function ReferralCard({ onRewardClaimed = null }) {
  const { t } = useTranslation();
  const posthog = usePostHog();
  const [builderOpen, setBuilderOpen] = useState(false);

  const openBuilder = () => {
    posthog?.capture('referral_builder_opened');
    setBuilderOpen(true);
  };

  const closeBuilder = () => {
    setBuilderOpen(false);
    if (onRewardClaimed) onRewardClaimed();
  };

  return (
    <div className="reward-card">
      <div className="reward-content">
        <div className="reward-header">
          <h4>
            <IconUsers size={20} style={{ marginRight: '8px' }} />
            {t('diamondsPage.inviteFriend', 'Invite a friend')}
          </h4>
          <span className="reward-value">+5 💎</span>
        </div>
        <p>
          {t('diamondsPage.inviteFriendDescReal', "Build a map for a friend and share the link. When they join with Strava as a new member, their map is free and you both get 5 diamonds.")}
        </p>
        <button type="button" className="reward-button" onClick={openBuilder}>
          {t('diamondsPage.createInvite', 'Make a map for a friend')}
        </button>
      </div>
      {builderOpen && <ReferralInviteBuilder onClose={closeBuilder} />}
    </div>
  );
}

export default ReferralCard;
